import {clsx} from "clsx";
import {twMerge} from "tailwind-merge";

/**
 * Composes Tailwind class strings.
 * - Uses clsx for conditional joining
 * - Uses tailwind-merge to dedupe conflicting utilities
 *   (e.g. cn("px-2", "px-4") => "px-4")
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
